import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from "@angular/core";
import { IBadgeComponent, IButtonDirective, IIconComponent, ITooltipDirective } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { FormPreviewSplitStateService } from "@m19-board/shared/form-preview-split/form-preview-split-state.service";

const LG_MIN_WIDTH_QUERY = "(min-width: 1024px)";

function initialOpen(): boolean {
  return typeof window !== "undefined" && window.matchMedia(LG_MIN_WIDTH_QUERY).matches;
}

@Component({
  selector: "app-form-preview-split",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, IButtonDirective, IIconComponent, IBadgeComponent, ITooltipDirective],
  host: {
    class: "flex min-h-0 flex-col",
  },
  templateUrl: "./form-preview-split.component.html",
})
export class FormPreviewSplitComponent {
  private readonly sharedState = inject(FormPreviewSplitStateService, { optional: true });

  readonly badgeLabelKey = input<string>("form-preview-split.preview");

  private readonly localOpen = signal(initialOpen());

  protected readonly open = computed(() => this.sharedState?.open() ?? this.localOpen());

  protected toggle(): void {
    if (this.sharedState) {
      this.sharedState.toggle();
      return;
    }
    this.localOpen.update((value) => !value);
  }
}
